



















































import HeaderBase from "../../components/organisms/HeaderBase.vue";

import { Vue, Component, Prop } from "vue-property-decorator";
import ProfielEditButton from "../../components/button/ProfielEditButton.vue";
import FindTeacherButton from "../../components/button/FindTeacherButton.vue";
import { Session } from "../../utils/Session";
import { ContextDataServiceExt } from "../../../src_client/biz/ContextDataServiceExt";
import { ContextDTO } from "../../../src_server/entity/dto/ContextDTO";
import { routeHelper } from "../../utils/routeHelper";
import StudentDocumentListDialog from "./StudentDocumentListDialog.vue";
import LineOfficialConnectionDialog from "../../components/line/LineOfficialConnectionDialog.vue";
import MaintenunceSelectDialog from "./MaintenunceSelectDialog.vue";
import { getBuildingName } from "../../../src_server/entity/master/buildingData";
@Component({
  components: {
    ProfielEditButton,
    FindTeacherButton,
    StudentDocumentListDialog,
    LineOfficialConnectionDialog,
    MaintenunceSelectDialog,
    HeaderBase,
  },
})
export default class StudentHeaderNavigation extends Vue {
  private context = new ContextDTO();

  @Prop({ default: true })
  private hasProfielButton!: boolean;

  @Prop({ default: true })
  private hasTeacherFindButton!: boolean;

  private get notReadingCount() {
    return Session.getContext()?.not_reading_count || 0;
  }

  get findTeacherButtonTitle() {
    if (Session.isCircleOBuilding()) {
      return "先生を探す";
    } else {
      return "予約する";
    }
  }

  get isPropertyPage() {
    return ["StudentInfoInputMain", "StudentSettingMain"].includes(
      this.$router.currentRoute.name ?? ""
    );
  }

  get logoutTo() {
    if (Session.isCircleOBuilding()) {
      return "/";
    } else {
      return "/entrance-page-da";
    }
  }

  private get logoLink() {
    return `/student-dashboard-page?building=${Session.getSessionBuildingId()}`;
  }

  goProfielEditPage() {
    routeHelper(this, "StudentInfoInputMain");
  }

  goProfielREEditPage() {
    const dialog = this.$refs["MaintenunceSelectDialog"] as MaintenunceSelectDialog;
    dialog.show();
  }

  goLessonReservationPage() {
    if (Session.isCircleOBuilding()) {
      routeHelper(this, "StudentLessonListPage");
    } else {
      routeHelper(this, "StudentLessonListDaPage");
    }
  }

  gotoLessonMessage() {
    routeHelper(this, "StudentMessagesPage");
  }

  showDocumentList() {
    (this.$refs["StudentDocumentListDialog"] as StudentDocumentListDialog).show();
  }

  async created() {
    // コンテキストを取得
    const contextBiz = new ContextDataServiceExt();
    const context = await contextBiz.getContext();
    if (context) {
      this.context = context;
    }

    if (!Session.isCircleOBuilding()) {
      document.title = `${getBuildingName(Session.getSessionBuildingId())}`;
    }
  }
}
